import script from "./LayoutHome.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutHome.vue?vue&type=script&setup=true&lang=js"

import "./LayoutHome.vue?vue&type=style&index=0&id=57bee3ce&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57bee3ce"]])

export default __exports__